// extracted by mini-css-extract-plugin
module.exports = {"belowForm":"search-form_belowForm_3YuVY","results":"search-form_results_1Hu_f","searchForm":"search-form_searchForm_37Rz3","main":"search-form_main_2OZGn"};